'use strict';
angular
    .module('iWoAtlas', ['mgcrea.ngStrap.button', 'trsspliceStringModule', 'atlasEditImageModule', 'util.ueditorForAtlas'])
    .controller('iWoAtlasController', [
        '$scope',
        'beforeonload',
        '$element',
        '$compile',
        '$window',
        '$q',
        '$location',
        '$anchorScroll',
        '$timeout',
        '$stateParams',
        '$sce',
        '$validation',
        '$state',
        '$filter',
        'trsHttpService',
        'storageListenerService',
        'initiWoDataService',
        'jsonArrayToStringService',
        'modalDialog',
        'iWoService',
        'initSingleSelecet',
        'myManuscriptService',
        'editingCenterService',
        'initeditctrBtnsService',
        'filterEditctrBtnsService',
        'iWoinitBtnService',
        'iWoBtnService',
        'ueditorService',
        'localStorageService',
        'editPictureService',
        'sensitiveWordCheckService',
        'editIsLock',
        'messagePublishService',
        function (
            $scope,
            beforeonload,
            $element,
            $compile,
            $window,
            $q,
            $location,
            $anchorScroll,
            $timeout,
            $stateParams,
            $sce,
            $validation,
            $state,
            $filter,
            trsHttpService,
            storageListenerService,
            initiWoDataService,
            jsonArrayToStringService,
            modalDialog,
            iWoService,
            initSingleSelecet,
            myManuscriptService,
            editingCenterService,
            initeditctrBtnsService,
            filterEditctrBtnsService,
            iWoinitBtnService,
            iWoBtnService,
            ueditorService,
            localStorageService,
            editPictureService,
            sensitiveWordCheckService,
            editIsLock,
            messagePublishService
        ) {
            initStatus();
            initData();
            editingCenterService.disabledDndDropOnOutlist($scope);

            $scope.moveUploadImg = function (index) {
                $scope.list.DOC_PICTURELIST.splice(index, 1);
            };

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.page = {
                    CURRPAGE: 1,
                    PAGESIZE: 20,
                };
                $scope.status = {
                    newsFormError: [],
                    nopayment: false,
                    switch: 'manuscriptInfo', // 默认选中稿件信息
                    openBtn: true,
                    mediaTypes: [],
                    isRequest: true,
                    hasVersionTime: false,
                    zhengwen: false,
                    uploaderImgSelected: [],
                    audioVideoidsArray: [], // 播放音视频临时数组
                    isCheckSensitiveWords: false,
                    sensitiveWordTit: '敏感词校验',
                    isEditDraft: !!$stateParams.iwometadataid,
                    isFusionEditor: $state.current.name === 'fusionatlas', // 是否来自融合编辑器
                    metadataid: $stateParams.iwometadataid,
                };
                $scope.data = {
                    userName: '',
                    selectedImg: {},
                    docgenre: [],
                    version: [],
                    copyVersion: [],
                    comment: {
                        comment: [],
                        voiceObj: {},
                        hasMore: false,
                        currPage: 1,
                    },
                    path: {
                        '-1': 'editingCenterIwoPersonalVersionTime',
                        '1': 'editingCenterAppPersonalVersionTime',
                        '2': 'editingCenterWebsitePersonalVersionTime',
                        '3': 'editingCenterPaperPersonalVersionTime',
                        '4': 'editingCenterWeixinPersonalVersionTime',
                    },
                    selectedVideoArray: [], // 选择的视频
                };
                $anchorScroll.yOffset = 63;
                $scope.handleBtnClick = function (funname) {
                    eval('$scope.' + funname + '()');
                };
                initSingleSelecet.getChannelList().then(function (data) {
                    $scope.status.mediaTypes = data;
                });
                emitCloseWindow();
                $scope.editFlag = {
                    media: 'iwo',
                    docType: 'atlas',
                };
            }

            /**
             * [theFormError description] 获取表单变化
             * @return {[type]} [description]
             */
            $scope.theFormError = function () {
                // 当表单发生变化时会进入方法
                var errorArray = [];
                for (var error in $scope.atlasForm.$error) {
                    errorArray.push(error);
                }
                $scope.status.newsFormError = !$scope.status.newsFormError ? [] : $scope.status.newsFormError;
                if ($scope.status.newsFormError.length !== errorArray.length) {
                    // 长度不相等说明表单errorname发生变化
                    $scope.status.newsFormError = errorArray;
                }
                return $scope.status.newsFormError; // 返回
            };

            /**
             * [toggleEditor description] 切换编辑器显隐
             * @return {[type]} [description]
             */
            $scope.toggleEditor = function () {
                $scope.status.zhengwen = !$scope.status.zhengwen;
                if ($scope.status.zhengwen) {
                    // 隐藏编辑器
                    $('.body_manuscript_content').addClass('editorHidden');
                } else {
                    $('.body_manuscript_content').removeClass('editorHidden');
                }
            };

            /**
             * [emitCloseWindow description]标签页关闭页面时，发送稿件解锁信息给其他页面，协助解锁该稿件
             * @return {[type]} [description]
             */
            function emitCloseWindow() {
                editingCenterService.allAppCloseWindow($scope, { typeName: 'iwo', saveLocal: false });
            }

            /**
             * [initData description]初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                storageListenerService.removeListener('iwo');
                if (!$scope.status.isFusionEditor) {
                    ($stateParams.iwometadataid ? initEditData() : initNewData()).then(function () {
                        beforeonload.beforeonloadAlert($scope);
                    });
                }
            }

            /**
             * [initEditData description] 编辑数据
             * @param {[fun]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[undefined]} [description]
             */
            function initEditData(dealWithListFun) {
                var defer = $q.defer();
                iWoService.getPicsDoc($stateParams.iwometadataid).then(function (data) {
                    $scope.list = data;
                    $scope.data.remarks = data.REMARKS;
                    document.title = data.TITLE;
                    $scope.status.audioVideoidsArray = angular.copy($scope.list.VIDEOREL);
                    $scope.status.incomeData = [
                        {
                            TITLE: $scope.list.TITLE,
                            CHNLDOCID: $stateParams.iwochnldocid,
                            METADATAID: $stateParams.iwometadataid,
                        },
                    ];
                    reWriteImgData($scope.list);
                    initKeyWords();
                    getVersion();
                    // 获取评审意见
                    getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
                    // 初始化原创类型
                    initDocgenre();
                    // 融合编辑器下处理list
                    if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                        dealWithListFun();
                    }
                    loadDirective().then(function () {
                        defer.resolve();
                    });
                });
                return defer.promise;
            }

            /**
             * [initNewData description] 新建数据
             * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
             * @return {[type]} [description]
             */
            function initNewData(dealWithListFun) {
                var defer = $q.defer();
                $scope.list = initiWoDataService.initAtlas();
                $scope.list.AUDIOVIDEO = []; // 将音视频文件转换为数组格式
                $scope.showIcon = true;
                initDocPictureList();
                initKeyWords();
                initDocgenre();
                // 融合编辑器下处理list
                if ($scope.status.isFusionEditor && angular.isFunction(dealWithListFun)) {
                    dealWithListFun();
                }
                loadDirective().then(function () {
                    defer.resolve();
                });
                return defer.promise;
            }

            /**
             * [initDocPictureList description] 初始化图集稿图片列表，主要是因为im可以创建图集稿，通过localstorage存储图片列表
             * @return  {[type]}   [return description]
             */
            function initDocPictureList() {
                if ($state.params.from === 'IM') {
                    var pictureList = localStorageService.get('IMMaterial');
                    if (pictureList) {
                        localStorageService.remove('IMMaterial');
                        $scope.list.DOC_PICTURELIST = pictureList;
                    }
                }
            }

            /**
             * [initDocgenre description]初始化稿件体裁
             * @return {[type]} [description]
             */
            function initDocgenre() {
                iWoService.initData().then(function (data) {
                    $scope.DOCGENRES = data.DocGenre;
                    if (!angular.isDefined($stateParams.iwometadataid)) {
                        $scope.list.DOCGENRE = angular.copy($scope.DOCGENRES[0]);
                    }
                });
            }

            /**
             * [initKeyWords description] 初始化关键词
             * @return  {[type]}  [return description]
             */
            function initKeyWords() {
                if (angular.isDefined($scope.list.KEYWORDS) && $scope.list.KEYWORDS !== '') {
                    var KEYWORDS = $scope.list.KEYWORDS.split(';');
                    $scope.data.KEYWORDS = [];
                    angular.forEach(KEYWORDS, function (data, index, array) {
                        $scope.data.KEYWORDS.push({
                            name: data,
                        });
                    });
                } else {
                    $scope.data.KEYWORDS = [];
                }
            }

            /* 锚点切换开始*/
            $scope.goto = function (id) {
                $location.hash(id);
                $anchorScroll();
            };

            /**
             * [getKeyWords description] 组装关键词为数组开始
             * @return  {[type]}  [return description]
             */
            function getKeyWords() {
                $scope.list.KEYWORDS = '';
                angular.forEach($scope.data.KEYWORDS, function (data, index, array) {
                    if (index != $scope.data.KEYWORDS.length - 1) {
                        $scope.list.KEYWORDS += data.name + ';';
                    } else {
                        $scope.list.KEYWORDS += data.name;
                    }
                });
            }
            // 组装关键词为数组结束

            // 说明引用到全部
            $scope.declareAll = function (index) {
                modalDialog.confirmModal('同步', '确定同步该说明到其它图片？', function () {
                    var text = $scope.list.DOC_PICTURELIST[index].APPDESC;
                    angular.forEach($scope.list.DOC_PICTURELIST, function (data, key) {
                        $scope.list.DOC_PICTURELIST[key].APPDESC = text;
                    });
                });
            };

            // 检验关键词的总个数和总记录长度
            $scope.invalidTag = function (tag) {
                var reg = /^[^<>\/;]*$/;
                if (tag.name.length > 20) {
                    $scope.isShowKeywordTips = true;
                    $scope.data.KEYWORDSTips = '单个关键词长度不能超过20';
                }
                if (!reg.test(tag.name)) {
                    $scope.isShowKeywordTips = true;
                    $scope.keywordsTips = '不能包含特殊字符';
                }
            };
            $scope.checkTag = function (tag) {
                var len = $scope.data.KEYWORDS.length;
                if (len == 10) {
                    $scope.isShowKeywordTips = true;
                    $scope.data.KEYWORDSTips = '关键词个数不能超过10个';
                    return false;
                } else {
                    $scope.data.KEYWORDSTips = '';
                    $scope.isShowKeywordTips = false;
                }
                if (tag.name.indexOf(' ') > -1) {
                    var spaceArr = tag.name.split(' ');
                    $timeout(function () {
                        $scope.data.KEYWORDS.pop();
                        var containArr = [];
                        for (var j = 0; j < $scope.data.KEYWORDS.length; j++) {
                            containArr.push($scope.data.KEYWORDS[j].name);
                        }
                        for (var i = 0; i < spaceArr.length; i++) {
                            if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                                $scope.data.KEYWORDS.push({ name: spaceArr[i] });
                                containArr.push(spaceArr[i]);
                            }
                        }
                    });
                }
            };
            $scope.enter = function () {
                var reg = /^[^<>\/]*$/;
                if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                    $scope.isShowKeywordTips = true;
                }
            };
            $scope.save = function () {
                var defer = $q.defer();
                save(true).then(
                    function (data) {
                        if ($scope.$root.cureditpage === undefined || $scope.$root.cureditpage === 'iwoatlas') {
                            editIsLock.lockDraft($stateParams.iwometadataid);
                            getVersion($scope.list.METADATAID);
                            $scope.status.openBtn = true;
                            iWoService.getPicsDoc($stateParams.iwometadataid).then(function (data) {
                                reWriteImgData(data);
                                $scope.status.openBtn = true;
                                var ue = UE.getEditor('ueditor');
                                ue.ready(function () {
                                    messagePublishService.publish('ueReady');
                                    ue.setContent(data.HTMLCONTENT);
                                });
                            });
                        }
                        defer.resolve();
                    },
                    function (msg) {
                        defer.reject(msg);
                    }
                );
                return defer.promise;
            };

            /**
             * [calculateWordNum description] 计算图集稿字数,图集说明字数+各图说字数,但图集说明中的字数为图集说明中输入的字数不为图集稿总字数
             * @param   {[type]}  list  [list description]
             * @return  {[type]}        [return description]
             */
            function calculateWordNum(list) {
                var len = 0;
                angular.forEach($scope.list.DOC_PICTURELIST, function (value, key) {
                    if (angular.isDefined(value.APPDESC)) {
                        len += value.APPDESC.length;
                    }
                });
                list.DOCWORDSCOUNT += len;
            }
            $scope.updateCKSelection = function (list) {
                list.ISNOPAYMENT === '1' ? (list.ISNOPAYMENT = '0') : (list.ISNOPAYMENT = '1');
            };

            /**
             * [manageDataBeforeSave description]处理保存前的数据
             * @return {[type]} [description]
             */
            function manageDataBeforeSave() {
                $scope.status.openBtn = false;
                $scope.atlasForm.$setPristine();
                getKeyWords();
                var methodname = ['savePersonalPicsDoc', 'saveReceivedPicsDoc'];
                $scope.list.SERVICEID = 'mlf_myrelease';
                $scope.list.METHODNAME = $state.params.fromType ? 'saveDeptNews' : methodname[$stateParams.iwoplatform];
                $scope.list.DOCRELTIME = $filter('date')(new Date(), 'yyyy-MM-dd HH:mm').toString();
                $scope.list.ORIGINALTYPE = $scope.data.originType;
                $scope.list.SPECIALDOC = $scope.data.specialDoc;
                $scope.list.CONTRIBUTORSAUTHER = $scope.data.userName;
                $scope.list.DeptmentalDocId = $state.params.departmentaldocid;
                var list = angular.copy($scope.list);
                calculateWordNum(list);
                delete list.RELEVANTNEWS;
                delete list.RELEVANTOFFICIALS;
                delete list.OBJ_VERSION;
                delete list.LOG_OPERATION;
                delete list.FZ_DOCS;
                // 处理发稿单作者信息空数据提交问题
                if (
                    angular.isDefined(list.FGD_AUTHINFO[0]) &&
                    (!angular.isDefined(list.FGD_AUTHINFO[0].USERNAME) || list.FGD_AUTHINFO[0].USERNAME === '')
                ) {
                    list.FGD_AUTHINFO = [];
                }
                // 处理发稿单作者信息空数据提交问题
                list.PICTURELIST = list.DOC_PICTURELIST; // PICTURELIST是做新媒体渠道时添加的，为了兼容性，需把两边的值保持一致
                list = jsonArrayToStringService.jsonArrayToString(list);
                return list;
            }

            /**
             * [manageDataAfterSave description]处理保存后的数据
             * @param  {[obj]} data [description]保存后返回值
             * @param  {[boolean]} flag [description]标识位
             * @return {[type]}      [description]
             */
            function manageDataAfterSave(data, flag) {
                $scope.status.openBtn = true;
                $scope.status.isEditDraft = true;
                $stateParams.iwometadataid = $scope.list.METADATAID = data.METADATAID;
                $stateParams.iwochnldocid = $scope.list.CHNLDOCID = data.CHNLDOCID;
                // 为父窗口传递成功的稿件id编号
                if (window.opener && window.opener.vuexStore) {
                    window.opener.vuexStore.newManuId = data.METADATAID;
                }
                $scope.status.incomeData = [
                    {
                        TITLE: $scope.list.TITLE,
                        CHNLDOCID: $stateParams.iwochnldocid,
                        METADATAID: $stateParams.iwometadataid,
                    },
                ];
                $scope.status.nopayment = true;
                if (flag) {
                    if (!$scope.status.isFusionEditor) {
                        storageListenerService.addListenerToIwo('newsSaved');
                        $state.transitionTo($state.current, $stateParams, {
                            reload: false,
                        });
                    }
                    if (!$scope.status.isFusionEditor) {
                        $timeout(function () {
                            modalDialog.saveModel('保存成功', '', 'success');
                        }, 500);
                    }
                    // editingCenterService.upDateVideoRelation($scope.data.editorDetail, $scope.data.METADATAID, $scope.list.TITLE, $scope.status.isFusionEditor);
                } else {
                    $scope.params = {};
                }
            }

            /**
             * [saveContent description] 保存正文
             * @return  {[type]}  [return description]
             */
            function saveContent() {
                if (!$scope.status.isFusionEditor) {
                    ueditorService.saveContent($scope.list);
                }
            }

            /**
             * [save description] 保存方法
             * @param   {[boolean]}  flag  [flag description] 标识
             * @return  {[type]}           [return description]
             */
            function save(flag) {
                $scope.status.isedit = !!$stateParams.iwometadataid;
                saveContent();
                $scope.atlasForm.$setDirty();
                var deferred = $q.defer();
                //  var isHasImg = examImg();
                $validation.validate($scope.atlasForm.authorForm);
                $scope.atlasForm.$pending = {};
                $validation
                    .validate($scope.atlasForm)
                    .success(function () {
                        modalDialog.isSecretInformation(
                            $stateParams.iwometadataid,
                            function () {
                                sensitiveWordCheckService.sensitiveWords($scope).then(
                                    function (sensitiveWords) {
                                        $scope.list.ISCONTAINSENSITIVEWORDS = !!sensitiveWords.length ? 1 : 0;
                                        $scope.list.SENSITIVEWORDS = sensitiveWords;
                                        var list = manageDataBeforeSave();
                                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), list, 'post').then(
                                            function (data) {
                                                $scope.data.METADATAID = data.METADATAID;
                                                if (!$scope.status.isedit) {
                                                    $scope.status.isedit = false;
                                                } else {
                                                    $scope.status.isedit = true;
                                                }
                                                if ($scope.data.selectedReport) {
                                                    myManuscriptService.relatedReport({
                                                        ReportId: $scope.data.selectedReport.NEWREPORTID || 0, // 关联的报题id，删除关联波提关系是传0
                                                        MetaDataId: $stateParams.iwometadataid || data.METADATAID, // 稿件id
                                                        Title: $scope.list.TITLE, // 稿件名称
                                                        MediaType: -1, // 渠道类型参数
                                                    });
                                                }
                                                if ($scope.data.selectedTask) {
                                                    myManuscriptService.relatedTask({
                                                        TaskCommandId: $scope.data.selectedTask.TASKCOMMANDID || 0, // 关联的任务id，删除关联波提关系是传0
                                                        MetaDataId: $stateParams.iwometadataid || data.METADATAID, // 稿件id
                                                        Title: $scope.list.TITLE, // 稿件名称
                                                        MediaType: -1, // 渠道类型参数
                                                    });
                                                }
                                                manageDataAfterSave(data, flag);
                                                beforeonload.refresh($scope);
                                                deferred.resolve(data);
                                            },
                                            function (data) {
                                                $scope.status.openBtn = true;
                                                deferred.reject(data);
                                            }
                                        );
                                    },
                                    function () {
                                        $scope.status.isCheckSensitiveWords = Math.random();
                                        deferred.reject();
                                    }
                                );
                            },
                            function () {
                                deferred.reject();
                            },
                            $scope.status.isFusionEditor
                        );
                    })
                    .error(function () {
                        editingCenterService.checkSaveError($scope.atlasForm, $element, $scope); // 定位输入错的表单位置
                        deferred.reject({
                            plat: '基础稿'
                        });
                    });
                return deferred.promise;
            }

            // 多渠道提交触发
            $scope.iWoSubmit = function () {
                save(false).then(function () {
                    saveSubmit();
                });
            };
            // 共享触发（个人稿库+已收稿库）
            $scope.iWoshare = function () {
                save(false).then(function (data) {
                    saveShare(data.METADATAID, data.CHNLDOCID);
                });
            };

            /**
             * [saveSubmit description]多渠道提交函数
             * @return  {[type]}  [return description]
             */
            function saveSubmit() {
                var methodname = ['personalSubmitMedia', 'receivedSubmitMedia'];
                myManuscriptService.submit(
                    $scope.status.incomeData,
                    function () {
                        storageListenerService.addListenerToIwo('newsSubmit');
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    },
                    function () { },
                    methodname[$stateParams.iwoplatform]
                );
            }
            // 多渠道提交函数结束

            /**
             * [saveShare description]共享函数开始
             * @param   {[type]}  metadataid  [metadataid description]
             * @param   {[type]}  chnldocid   [chnldocid description]
             * @return  {[type]}              [return description]
             */
            function saveShare(metadataid, chnldocid) {
                var shareMethod = ['personalMyShare', 'receivedMyShare'];
                editingCenterService.share(function (data) {
                    data.serviceid = 'mlf_myrelease';
                    data.methodname = shareMethod[$stateParams.iwoplatform];
                    data.ChnlDocIds = chnldocid;
                    data.MetaDataIds = metadataid;
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), data, 'post').then(function (data) {
                        modalDialog.alertType('共享成功', '', 'success', false, function () {
                            storageListenerService.addListenerToIwo('newsShared');
                            var opened = $window.open('about:blank', '_self');
                            opened.close();
                        });
                    });
                });
            }
            // 共享函数结束

            /**
             * [draft description]传稿函数
             * @return  {[type]}  [return description]
             */
            function draft() {
                var menthod = ['personalTransferMetaDatas', 'receivedTransferMetaDatas'];
                myManuscriptService.draft(
                    '传稿',
                    $scope.status.incomeData,
                    function () {
                        storageListenerService.addListenerToIwo('newsPassed');
                        var opened = $window.open('about:blank', '_self');
                        opened.close();
                    },
                    function () { },
                    menthod[$stateParams.iwoplatform]
                );
            }
            // 传稿函数结束

            /**
             * [close description]页面关闭
             * @return {[type]} [description]
             */
            $scope.close = function () {
                closeCurrView();
            };

            /**
             * [closeCurrView description]关闭页面方法
             * @return  {[type]}  [return description]
             */
            function closeCurrView() {
                editingCenterService
                    .closeWinow($scope.atlasForm.$dirty, ueditorService.contentTranscoding($scope.list) != ueditorService.bindContent())
                    .then(
                        function () {
                            save().then(function () {
                                var opened = $window.open('about:blank', '_self');
                                opened.close();
                            });
                        },
                        function () {
                            var opened = $window.open('about:blank', '_self');
                            opened.close();
                        }
                    );
            }
            //  传稿(个人稿库+已收稿库)
            $scope.iWoTransfer = function () {
                save(false).then(function () {
                    draft();
                });
            };

            /**
             * [swapItems description]
             *
             * @param   {[type]}  list    [list description]
             * @param   {[type]}  index1  [index1 description]
             * @param   {[type]}  index2  [index2 description]
             *
             * @return  {[type]}          [return description]
             */
            function swapItems(list, index1, index2) {
                list[index1] = list.splice(index2, 1, list[index1])[0];
            }

            /** ***************************************图片相关处理开始*******************************************************************************/
            /* 批量上传图片模态框*/
            $scope.multiImgsUploader = function () {
                // 对接媒资库
                let options = {
                    resourceType: '0',
                    isMulti: true
                };
                editingCenterService.mediaSelector(options).then(function (result) {
                    var picList = [];
                    for (var l = 0; l < result.list.length; l++) {
                        // 我的图片已经选中的
                        var imgName = result.list[l].previewurl.substring(result.list[l].previewurl.lastIndexOf('\/') + 1).split('?')[0];
                        picList.push({
                            PERPICURL: result.list[l].resourceurl,
                            APPFILE: imgName,
                            APPDESC: result.list[l].resourcetitle,
                            APPSIZE: result.list[l].resourcesize,
                            meiziId: result.list[l].resourceid,
                            relationId: result.list[l].relationid
                        });
                    }
                    $scope.list.DOC_PICTURELIST = $scope.list.DOC_PICTURELIST.concat(picList);
                });
            };


            $scope.mediaSelector = function () {
                let options = {
                    resourceType: '0',
                    isMulti: false,
                    isResolve: true
                };
                editingCenterService.mediaSelector(options).then(function (result) {

                    var picList = [];
                    for (var l = 0; l < result.list.length; l++) {
                        picList.push({
                            PERPICURL: result.list[l].SRCIMGURL,
                            APPFILE: result.list[l].FILENAME,
                            APPDESC: result.list[l].FILEDESC.replace(/\.\w+$/, ''),
                            APPSIZE: result.list[l].FILESIZE,
                        });
                    }
                    $scope.list.DOC_PICTURELIST = $scope.list.DOC_PICTURELIST.concat(picList);
                });
            };

            /**
             * [editImage description]编辑图片模态窗
             * @param  {[obj]} image [description]被选中的图片
             * @param  {[num]} index [description]数组下标
             * @return {[type]}       [description]
             */
            $scope.editImage = function (image, index) {
                // editingCenterService.editUploaderImg(image, function(result) {
                //     $scope.list.DOC_PICTURELIST[index].PERPICURL = result.PERPICURL;
                //     $scope.list.DOC_PICTURELIST[index].APPFILE = result.APPFILE;
                //     $scope.list.DOC_PICTURELIST[index].APPDESC = result.APPDESC;
                //     delete $scope.list.DOC_PICTURELIST[index].APPENDIXID;
                //     //  if ($scope.list.DOC_PICTURELIST[0].PERPICURL) {
                //     //      $scope.showIcon = false;
                //     //  }
                // });
                // 对接媒资库
                let options = {
                    resourceType: '0',
                    isMulti: false
                };
                editingCenterService.mediaSelector(options).then(function (result) {
                    var imgName = result.list[0].previewurl.substring(result.list[0].previewurl.lastIndexOf('\/') + 1).split('?')[0];
                    $scope.list.DOC_PICTURELIST[index] = {
                        PERPICURL: result.list[0].resourceurl,
                        APPFILE: imgName,
                        APPDESC: result.list[0].resourcetitle,
                        APPSIZE: result.list[0].resourcesize,
                        meiziId: result.list[0].resourceid,
                        relationId: result.list[0].relationid
                    };
                });
            };

            /**
             * [reWriteImgData description]保存后回写图片数组
             * @param  {[obj]} data [description]保存后返回的图片数组
             * @return {[type]}      [description]null
             */
            function reWriteImgData(data) {
                var arrayDocPic = [];
                angular.forEach(data.DOC_PICTURELIST, function (data, index) {
                    arrayDocPic.push({
                        APPFILE: data.APPFILE,
                        APPDESC: data.APPDESC,
                        PERPICURL: data.PERPICURL,
                        APPENDIXID: data.APPENDIXID,
                    });
                });
                $scope.list.DOC_PICTURELIST = arrayDocPic;
            }
            // 图片上移开始
            $scope.upMove = function (index) {
                if (index !== 0) {
                    swapItems($scope.list.DOC_PICTURELIST, index, index - 1);
                }
            };

            // 图片下移开始
            $scope.downMove = function (index) {
                if (index !== $scope.list.DOC_PICTURELIST.length - 1) {
                    swapItems($scope.list.DOC_PICTURELIST, index, index + 1);
                }
            };

            // 全选批量上传后的图片
            $scope.selectAllImg = function () {
                $scope.status.uploaderImgSelected =
                    $scope.status.uploaderImgSelected.length === $scope.list.DOC_PICTURELIST.length ? [] : [].concat($scope.list.DOC_PICTURELIST);
            };
            // 选择批量上传后的图片
            $scope.selectImg = function (item) {
                if ($scope.status.uploaderImgSelected.indexOf(item) < 0) {
                    $scope.status.uploaderImgSelected.push(item);
                } else {
                    $scope.status.uploaderImgSelected.splice($scope.status.uploaderImgSelected.indexOf(item), 1);
                }
            };
            // 选择批量上传后的图片结束

            // 批量删除上传后的图片
            $scope.batchDelete = function () {
                modalDialog.confirmModal('删除', '是否确认删除选择的图片', function () {
                    var temp = [];
                    angular.forEach($scope.list.DOC_PICTURELIST, function (data, index, array) {
                        if ($scope.status.uploaderImgSelected.indexOf(data) < 0) {
                            temp.push(data);
                        }
                    });
                    $scope.list.DOC_PICTURELIST = temp;
                    $scope.status.uploaderImgSelected = [];
                });
            };
            // 批量删除上传后的图片结束

            // 单个删除批量上传后的图片
            $scope.deleteImg = function (ID) {
                modalDialog.confirmModal('删除', '确定删除？', function () {
                    $timeout(function () {
                        $scope.list.DOC_PICTURELIST.splice(ID, 1);
                    });
                });
            };

            /**
             * [multiImgsDownload description] 下载原图
             * @return {[type]} [description]
             */
            $scope.multiImgsDownload = function () {
                $scope.loadingPromise = editingCenterService.downloadOrgImgList($scope.status.uploaderImgSelected, 'PERPICURL', 'APPDESC');
            };

            /**
             * [multiImgsWatermark description]
             *
             * @return  {[type]}  [return description]
             */
            $scope.multiImgsWatermark = function () {
                editingCenterService.multiImgsWatermark($scope.status.uploaderImgSelected, 17).then((response) => {
                    for (var i = 0; i < $scope.list.DOC_PICTURELIST.length; i++) {
                        if (response.LIST[$scope.list.DOC_PICTURELIST[i].APPFILE]) {
                            $scope.list.DOC_PICTURELIST[i].PERPICURL = response.LIST[$scope.list.DOC_PICTURELIST[i].APPFILE].FILEURL;
                            $scope.list.DOC_PICTURELIST[i].APPFILE = response.LIST[$scope.list.DOC_PICTURELIST[i].APPFILE].FILENAME;
                            $scope.list.DOC_PICTURELIST[i].APPENDIXID = 0;
                        }
                    }
                });
            };
            /**
             * [photoCrop description]编辑裁剪图片
             *
             * @param   {[type]}  image  [image description]
             * @param   {[type]}  index  [index description]
             *
             * @return  {[type]}         [return description]
             */
            $scope.photoCrop = function (image, index) {
                editPictureService.editPicture(angular.copy(image), $stateParams.iwositeid, function (img) {
                    $scope.list.DOC_PICTURELIST[index].APPFILE = img.imgName;
                    $scope.list.DOC_PICTURELIST[index].PERPICURL = img.imgSrc;
                    $scope.list.DOC_PICTURELIST[index].SRCFILE = img.srcFile;
                    delete $scope.list.DOC_PICTURELIST[index].APPENDIXID;
                });
            };

            /** ********************************图片相关处理结束*************************************************************/


            /**
             * [getVersion description]获取流程版本与操作日志
             * @param   {[type]}  id  [id description]
             * @return  {[type]}      [return description]
             */
            function getVersion(id) {
                var metadataid = angular.isDefined(id) ? id : $stateParams.iwometadataid;
                editingCenterService.getEditVersionTime(metadataid, $scope.page, $scope.data.copyVersion).then(function (data) {
                    $scope.data.version = data;
                    $scope.page = data.page;
                    $scope.data.copyVersion = data.copyArray;
                    $scope.status.hasVersionTime = true;
                });
            }

            /**
             * [isShowVersion description] 没有操作日志或流程版本时不显示图标和'没有更多'
             * @param  {[type]}  key [description] 操作日志或流程版本的数据
             * @return {Boolean}     [description]
             */
            $scope.isShowVersion = function (key) {
                if (key === undefined) {
                    return false;
                } else {
                    for (var i in key) {
                        return true;
                    }
                    return false;
                }
            };

            /**
             * [getLoadMore description]操作日志加载更多
             * @return {[type]} [description]
             */
            $scope.getLoadMore = function () {
                $scope.page.CURRPAGE++;
                getVersion();
            };

            /**
             * [getComment description]获取评审意见
             *
             * @param   {[type]}  id        [id description]
             * @param   {[type]}  currPage  [currPage description]
             *
             * @return  {[type]}            [return description]
             */
            function getComment(id, currPage) {
                editingCenterService.getComment(id, currPage).then(function (data) {
                    if (
                        angular.isDefined($scope.data.comment.comment[$scope.data.comment.comment.length - 1]) &&
                        $filter('date')($scope.data.comment.comment[$scope.data.comment.comment.length - 1].day, 'yyyy-MM-dd').toString() ==
                        $filter('date')(data.comment[0].day, 'yyyy-MM-dd').toString()
                    ) {
                        $scope.data.comment.comment[$scope.data.comment.comment.length - 1].times = $scope.data.comment.comment[
                            $scope.data.comment.comment.length - 1
                        ].times.concat(data.comment[0].times);
                        data.comment.shift();
                    }
                    $scope.data.comment['comment'] = $scope.data.comment['comment'].concat(data.comment);
                    $scope.data.comment.hasMore = data.hasMore;
                    for (var i in data.voiceObj) {
                        $scope.data.comment.voiceObj[i] = data.voiceObj[i];
                    }
                });
            }

            /**
             * [getComment description]获取评审意见
             * @return {[type]} [description]
             */
            $scope.getLoadMoreComment = function () {
                $scope.data.comment.currPage += 1;
                getComment($stateParams.iwometadataid, $scope.data.comment.currPage);
            };

            /**
             * [politicalCommonSense description]正文政治常识校验
             * @return {[type]} [description]
             */
            $scope.politicalCommonSense = function () {
                editingCenterService.checkoutDraft(ueditorService.bindContent()).then(function (data) {
                    if (data.content[0].resultInfo.length > 0) {
                        var ue = UE.getEditor('ueditor');
                        ue.setContent(ueditorService.handlingSensitiveInf(data, ue.getContent()));
                    }
                });
            };

            /**
             * [trustUrl description]信任url
             */
            $scope.trustUrl = $sce.trustAsResourceUrl;

            /**
             * [loadDirective description]动态加载指令
             *
             * @return  {[type]}  [return description]
             */
            function loadDirective() {
                var defer = $q.defer();
                editingCenterService.loadManuscriptType($scope, $element); // 加载稿件原创部分
                if ($stateParams.issave === undefined || $stateParams.issave === '0') {
                    // 用于融合编辑器的虚拟表单校验，虚拟表单检验不需要加载编辑器
                    LazyLoad.js(['./lib/ueditor2/ueditor.config.js?v=11.5', './lib/ueditor2/ueditor.all.js?v=11.8'], function () {
                        //  $scope.button = { title: "政治常识校对", name: "polComSense" };
                        var $ueditor = $('<ueditor-for-atlas list="list" edit-flag="editFlag" class="newEditor"></ueditor-for-atlas>');
                        $element.find('ueditorLocation').append($ueditor);
                        $ueditor = $compile($ueditor)($scope);
                        var ue = UE.getEditor('ueditor');
                        ue.ready(function () {
                            messagePublishService.publish('ueReady');
                            defer.resolve();
                        });
                    });
                    var supportCreation =
                        '<support-creation media-type={{\'0\'}} has-editor="true" toggle-sidebar="true" is-check-sensitive-words="status.isCheckSensitiveWords" list="list"></support-creation>';
                    supportCreation = $compile(supportCreation)($scope);
                    $element.find('supportcreation').append(supportCreation);
                } else {
                    defer.resolve();
                }
                if (!$scope.status.isFusionEditor) {
                    var draftList =
                        '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                        '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                }
                return defer.promise;
            }
            $scope.getKeywordsOrAbstract = function (type) {
                editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContent()).then(
                    function (data) {
                        if (type === 'keywords') {
                            if (data !== '""') {
                                var keywordsArray = data.substring(1, data.length - 1).split(';');
                                var arr = [];
                                angular.forEach(keywordsArray, function (value, key) {
                                    arr.push({
                                        name: value,
                                    });
                                });
                                $scope.data.KEYWORDS = angular.isArray($scope.data.KEYWORDS) ? $scope.data.KEYWORDS : [];
                                $scope.data.KEYWORDS = $scope.data.KEYWORDS.concat(arr);
                                $scope.data.KEYWORDS = $filter('unique')($scope.data.KEYWORDS, 'name');
                                if ($scope.data.KEYWORDS.length > 10) {
                                    $scope.data.KEYWORDS = $scope.data.KEYWORDS.splice(0, 10);
                                }
                            } else {
                                return;
                            }
                        }
                        if (type === 'abstract') {
                            //  $scope.list.ABSTRACT = data.content.join("");
                            $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                        }
                    },
                    function (data) { }
                );
            };

            /**
             * [clearAllKeywords description]清空关键词
             * @return {[type]} [description]
             */
            $scope.clearAllKeywords = function () {
                $scope.data.KEYWORDS = [];
            };

            /**
             * [openPersonalVersionTime description] 打开流程版本详情页
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.openPersonalVersionTime = function (item) {
                var path = $scope.data.path[item.MEDIATYPE];
                var params = {
                    objectversionid: item.OBJECTVERSIONID,
                    chnldocid: $stateParams.iwochnldocid,
                };
                var url = $state.href(path, params);
                item.url = url;
            };

            /* 融合编辑器额外功能开始*/
            if ($scope.status.isFusionEditor) {

                /**
                 * [pageCantEdit description] 已提交渠道编辑页不能编辑
                 * @param  {[type]} type [description] 稿件信息或属性信息
                 * @return {[type]}      [description]
                 */
                $scope.pageCantEdit = function (type) {
                    $timeout(function () {
                        if (type == 'manuscriptInfo') {
                            var manuHeight = $('.body_manuscript').height();
                            var manuWidth = $('.body_manuscript').width();
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height(manuHeight)
                                .width(manuWidth);
                            $('.body_manuscript').resize(function () {
                                $('.pageCantEdit')
                                    .find('.cantEditPart')
                                    .height($(this).height());
                            });
                        } else if (type == 'attrInfo') {
                            var attrHeight = $('.body_attr_info').height();
                            var attrWidth = $('.body_attr_info').width();
                            $('.pageCantEdit')
                                .find('.cantEditPart')
                                .height(attrHeight)
                                .width(attrWidth);
                            $('.body_attr_info').resize(function () {
                                $('.pageCantEdit')
                                    .find('.cantEditPart')
                                    .height($(this).height());
                            });
                        }
                    }, 300);
                };

                /**
                 * [initData description] 融合编辑器切换渠道时的初始化数据
                 * @param {[type]} [dealWithListFun] [description] 融合编辑器下处理list的方法
                 * @return {[type]} [description]
                 */
                $scope.initData = function (dealWithListFun) {
                    var defer = $q.defer();
                    if (angular.isDefined($stateParams.iwometadataid)) {
                        initEditData(dealWithListFun).then(function () {
                            defer.resolve();
                        });
                    } else {
                        initNewData(dealWithListFun).then(function () {
                            defer.resolve();
                        });
                    }
                    return defer.promise;
                };

                /**
                 * [loadFgd description] 加载发稿单
                 * @return {[type]} [description]
                 */
                $scope.loadFgd = function () {
                    var draftList =
                        '<editor-dir list="list"  meta-data-id="{{list.METADATAID}}" editor-json="list.FGD_EDITINFO" editor-form="newsForm"></editor-dir>' +
                        '<editor-auth-dir author="list.FGD_AUTHINFO" originalchildtype="list.ORIGINAL==1&&data.originType==3?1:0"></editor-auth-dir>';
                    draftList = $compile(draftList)($scope);
                    $element.find('editor').append(draftList);
                };
            }

            /* 融合编辑器额外功能结束*/
        },
    ]);
